var _a, _b;
import * as React from 'react';
import { routes } from '@lean-body/src/route';
import { css, StyleSheet } from 'aphrodite';
import { FIXED_FOOTER_HEIGHT, PageLoading, UnsubscribeWarning } from '@lean-body/components/organisms';
import { Colors, MediaBreakPointUp, Sizes } from '@lean-body/components/styles';
import { SettingItemKeys } from '../organisms/setting_menu';
import { useNavigate } from 'react-router';
import { UnsubscribeChatbot } from '../organisms/unsubscribe_chatbot';
export var UnsubscribeCautionPage = function (_a) {
    var accountService = _a.accountService, alertPresenter = _a.alertPresenter, apiClient = _a.apiClient, tracker = _a.tracker, config = _a.config, profile = _a.profile;
    var navigate = useNavigate();
    var _b = React.useState(), me = _b[0], setMe = _b[1];
    React.useEffect(function () {
        accountService.fetchMe().then(function (v) {
            setMe(v);
            if (v.unsubscribeScheduledAt) {
                navigate("".concat(routes.SETTING.compile(), "?key=").concat(SettingItemKeys.plan));
                alertPresenter.showMessage('退会予約ずみです');
            }
            // 休眠中は退会できないようにリダイレクト
            if (v.isDormant) {
                navigate("".concat(routes.SETTING.compile(), "?key=").concat(SettingItemKeys.plan));
                alertPresenter.showMessage('休眠中は退会できません');
            }
        });
    }, []);
    if (!me)
        return React.createElement(PageLoading, null);
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.head) }, "\u9000\u4F1A\u624B\u7D9A\u304D"),
        React.createElement("div", { className: css(styles.content) },
            React.createElement(UnsubscribeWarning, { payment: me.payment, profile: profile }),
            React.createElement(UnsubscribeChatbot, { apiClient: apiClient, tracker: tracker, config: config }))));
};
var styles = StyleSheet.create({
    container: (_a = {
            backgroundColor: Colors.White,
            minHeight: "calc(100vh - ".concat(FIXED_FOOTER_HEIGHT, "px - ").concat(Sizes.MobileHeaderHeight, "px)"),
            padding: '0 30px 180px'
        },
        _a[MediaBreakPointUp.MD] = {
            minHeight: '100vh',
            paddingBottom: 0,
        },
        _a),
    head: {
        fontSize: 18,
        fontWeight: 'bold',
        padding: '40px 0 24px',
        textAlign: 'start',
        marginBottom: 30,
    },
    content: (_b = {},
        _b[MediaBreakPointUp.XL] = {
            maxWidth: 750,
            margin: '0 auto',
        },
        _b),
});
